import createGetFormValues from '../selectors/getFormValues';
import immutable from '../structure/immutable';

export default createGetFormValues(immutable);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/immutable/getFormValues.js
// module id = 1202
// module chunks = 0